import script from "./Evidencias.vue?vue&type=script&setup=true&lang=js"
export * from "./Evidencias.vue?vue&type=script&setup=true&lang=js"

import "./Evidencias.vue?vue&type=style&index=0&id=0ce2c3e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ce2c3e0"]])

export default __exports__